import { render, staticRenderFns } from "./AdSpaceSelectItem.vue?vue&type=template&id=ab018f0e&scoped=true"
import script from "./AdSpaceSelectItem.vue?vue&type=script&lang=ts"
export * from "./AdSpaceSelectItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab018f0e",
  null
  
)

export default component.exports